import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import ActivityTimeline from '../../TeamApplicants/components/ActivityTimeline'
import { ColumnDefWithFilters, ColumnGroup } from '../types'
import { useSimpleColumns } from '../utils'
import dayjs from 'dayjs'

const collectionGroups: ColumnGroup[] = [
  {
    id: 'achievements',
    header: 'Achievements',
    rankMode: 'sequential',
    rankFields: ['cutting_edge', 'ahead_of_the_curve'],
    subColumns: [
      {
        id: 'cutting_edge',
        size: 70,
        header: () => (
          <Tooltip>
            <TooltipTrigger>CE</TooltipTrigger>
            <TooltipContent>Cutting Edge</TooltipContent>
          </Tooltip>
        ),
        field: 'cutting_edge',
      },
      {
        id: 'ahead_of_the_curve',
        size: 70,
        header: () => (
          <Tooltip>
            <TooltipTrigger>AOTC</TooltipTrigger>
            <TooltipContent>Ahead of the Curve</TooltipContent>
          </Tooltip>
        ),
        field: 'ahead_of_the_curve',
      },
    ],
  },
  {
    id: 'raid_activity',
    header: 'Raid activity',
    rankFields: null,
    subColumns: [
      {
        id: 'timeline',
        header: () => (
          <div className='flex justify-between gap-2'>
            <span>2005</span>
            <span>{dayjs().format('YYYY')}</span>
          </div>
        ),
        cellWrapper: (_, member) => {
          return (
            <ActivityTimeline timeline={member?.timeline || []} hideLabels />
          )
        },
      },
    ],
  },
]

export const useRaidsTimelineColumns = (): ColumnDefWithFilters => {
  const columns = useSimpleColumns(collectionGroups)

  return { columns, initialSortBy: [{ id: 'achievements_rank', desc: false }] }
}
